// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outBox{width:100%;height:100%}.app-main{min-height:0;position:relative;overflow:hidden}.main-container{margin-left:50px!important;width:calc(100% - 50px)}.appFooter{font-size:12px;color:#bec9d2;line-height:20px;text-align:center}.iframe{height:calc(100vh - 50px);width:100%}", ""]);
// Exports
module.exports = exports;
